function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Arrow 2 - Right");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Styleguide",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Buttons--Copy",
  transform: "translate(-513.000000, -147.000000)"
}, React.createElement("g", {
  id: "Black",
  transform: "translate(287.000000, 144.000000)"
}, React.createElement("g", {
  id: "Arrow-2---Right",
  transform: "translate(224.000000, 0.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fillOpacity: 0,
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("path", {
  d: "M14.3241838,7.95111661 C14.2873549,8.07227035 14.2231921,8.18717907 14.1315147,8.28575311 L10.785871,11.8830797 C10.4724667,12.2200605 9.95887492,12.2400573 9.63269845,11.9218582 L9.68513323,11.9730105 C9.3616579,11.6574465 9.35316256,11.1288105 9.66689801,10.7914737 L11.964381,8.32115784 L2.77845573,8.32115784 C2.3485265,8.32115784 2,7.97240691 2,7.53544355 C2,7.10150553 2.35901727,6.74972927 2.77845573,6.74972927 L11.8920536,6.74972927 L9.66689801,4.35718178 C9.35316256,4.01984494 9.3616579,3.49120892 9.68513323,3.1756449 L9.63269845,3.22679728 C9.95887492,2.90859819 10.4724667,2.92859498 10.785871,3.26557577 L14.1315147,6.86290234 C14.1703095,6.90461551 14.2041772,6.94925372 14.2331316,6.99605242 C14.3641631,7.13632806 14.4444444,7.32572616 14.4444444,7.53544355 C14.4444444,7.68807749 14.4000261,7.83054622 14.3241838,7.95111661 Z",
  id: "Combined-Shape",
  fill: "#1E1F20"
})))));

var SvgRightarrow = function SvgRightarrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRightarrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rightarrow.db1f5b98.svg";
export { ForwardRef as ReactComponent };